import coreFocusImg from "./Images/Picture1.png";
import assetsImg from "./Images/Picture2.png";
import clientBaseImg from "./Images/Picture3.png";
import locationImg from "./Images/Picture4.png";
import NavBar from "./NavBar";
import "./AboutUs.css";

function AboutUs() {
  return (
    <div className="AboutUs">
      <NavBar />
      <div className="PageTitleBanner">
        <h1>About Us</h1>
      </div>
      <div className="AboutUs-Text">
        <div className="AboutUs-Content">
          <p className="AboutUs-Lead">
            The name Oakmere Capital reflects our investment philosophy. The
            'Oak' represents resilience, discipline, and the long-term
            stewardship of capital. The 'mere', another term for a lake, is
            shaped by its surrounding environment and symbolises depth,
            flexibility, and the ability to adapt to evolving conditions while
            remaining contained within clearly defined boundaries.
          </p>
          <p>
            At Oakmere Capital, we recognise that every individual and family is
            unique. This understanding drives our commitment to delivering
            investment solutions aligned with each client's specific objectives,
            risk profile, and long-term aspirations.
          </p>
        </div>
      </div>
      <div className="SubHeading">
        Oakmere Capital and Yellowwood Private Wealth - At a Glance
      </div>
      <div className="AtAGlance">
        <div className="AtAGlanceSub">
          <div className="TopText">Core Focus</div>
          <div className="img">
            <img src={coreFocusImg} alt="Core Focus" />
          </div>
          <div className="BottomText">
            Investment Management On A Global Basis
          </div>
        </div>
        <div className="AtAGlanceSub">
          <div className="TopText">Assets Under Management</div>
          <div className="img">
            <img src={assetsImg} alt="Assets Under Management" />
          </div>
          <div className="BottomText"> R1.1 Billion</div>
        </div>
        <div className="AtAGlanceSub">
          <div className="TopText">Client Base</div>
          <div className="img">
            <img src={clientBaseImg} alt="Client Base" />
          </div>
          <div className="BottomText">
            High Net-worth Individuals & Families
          </div>
        </div>
        <div className="AtAGlanceSub">
          <div className="TopText">Location</div>
          <div className="img">
            <img src={locationImg} alt="Location" />
          </div>
          <div className="BottomText">Based in South Africa</div>
        </div>
      </div>
      <footer className="ComplianceFooter">
        <p>
          Oakmere Capital is a Juristic Representative of Yellowwood Private
          Wealth. Yellowwood Private Wealth is an authorised financial services
          provider.
        </p>
        <p>FSP No 49879</p>
        <p>
          Copies of our complaints and conflicts of interest policies are
          available upon request.
        </p>
      </footer>
    </div>
  );
}

export default AboutUs;
